var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 27,
    viewBox: "0 0 25 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.13086 3.7002H20.1309C21.2309 3.7002 22.1309 4.6002 22.1309 5.7002V17.7002C22.1309 18.8002 21.2309 19.7002 20.1309 19.7002H4.13086C3.03086 19.7002 2.13086 18.8002 2.13086 17.7002V5.7002C2.13086 4.6002 3.03086 3.7002 4.13086 3.7002Z",
    stroke: "#55595F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1309 5.7002L12.1309 12.7002L2.13086 5.7002",
    stroke: "#55595F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.ea9521ec0b13a63e9c256610f6025ba4.svg";
export { ForwardRef as ReactComponent };